import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  // Modal,
  Button,
  Col,
  Offcanvas,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import { withCookies } from "react-cookie";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  addTask,
  updateTask,
  archiveTask,
  unArchiveTask,
} from "../../redux/actions/tasks";
import configVars from "../../config";
import AllComments from "../Comments/AllComments";
import History from "../History";

// Images
import noCommentImg from "../../images/noComment.png";
import PromptBox from "../PromptBox";

const { createSliderWithTooltip } = Slider;
const SliderWT = createSliderWithTooltip(Slider);
const wrapperStyle = { width: "100%" };

const IdeaBank = ({
  setApiLoading,
  show,
  handleClose,
  selectedTask,
  board,
  columnId,
  selectedColumn,
  droppableColumn,
  draggableColumn,
  handleArchive,
  handleUnarchive,
  handleDelete,
  columnTitle,
  getColumnNo,
  config,
  setShowCloseConfirmation,
  resetInitially = false,
  // onChangeSetConfirmationAsk,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [translation] = useTranslation("translations");
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  // state to show and hide update button
  const [showUpdateBtn, setShowUpdateBtn] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [displayPrompt, setDisplayPrompt] = useState(false);
  const [factors, setFactors] = useState("");
  const [factorsContentState, setFactorsContentState] = useState(null);
  const [investments, setInvestments] = useState(null);
  const [investmentsContentState, setInvestmentsContentState] = useState(null);
  const [idea, setIdea] = useState(null);
  const [ideaContentState, setIdeaContentState] = useState(null);
  const [effects, setEffects] = useState(null);
  const [effectsContentState, setEffectsContentState] = useState(null);
  const [loading, setLoading] = useState(false);
  const allComments = selectedTask?.comments ? selectedTask.comments : [];
  const [priority, setPriority] = useState(0);
  const resetState = useCallback(() => {
    setTitle({ value: "", error: false });
    setFactors(null);
    setInvestments(null);
    setEffects(null);
    setIdea(null);
    setEffectsContentState(null);
    setFactorsContentState(null);
    setInvestmentsContentState(null);
    setIdeaContentState(null);
    setPriority(0);
    setShowUpdateBtn(false);
    setShowSaveBtn(false);
  }, []);

  useEffect(() => {
    setFactors(null);
    setInvestments(null);
    setEffects(null);
    setIdea(null);
    setEffectsContentState(null);
    setFactorsContentState(null);
    setInvestmentsContentState(null);
    setIdeaContentState(null);
  }, [selectedTask]);

  useEffect(() => {
    if (resetInitially) {
      resetState();
    }
  }, [show, resetInitially, resetState]);

  useEffect(() => {
    if (selectedTask && show) {
      setTitle({ value: selectedTask.title, error: false });
      setPriority(
        selectedTask && parseInt(selectedTask?.priority)
          ? parseInt(selectedTask?.priority)
          : 0
      );

      let _factorDesc = null;
      if (selectedTask?.idea_bank_factor_description) {
        _factorDesc = selectedTask?.idea_bank_factor_description;
      } else if (selectedTask?.current_situation_factor_description) {
        _factorDesc = selectedTask?.current_situation_factor_description;
      } else if (selectedTask?.action_plan_factor_description) {
        _factorDesc = selectedTask?.action_plan_factor_description;
      }

      if (_factorDesc) {
        const contentBlock1 = htmlToDraft(_factorDesc);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setFactors(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setFactorsContentState(_contentState);
        } else {
          setFactors(null);
          setFactorsContentState(null);
        }
      }

      let _idea = null;
      if (selectedTask?.action_plan_decided_action) {
        _idea = selectedTask?.action_plan_decided_action;
      } else if (selectedTask?.idea_for_change_description) {
        _idea = selectedTask?.idea_for_change_description;
      } else if (selectedTask?.implementation_decided_action) {
        _idea = selectedTask?.implementation_decided_action;
      } else if (selectedTask?.evaluation_result) {
        _idea = selectedTask?.evaluation_result;
      }

      if (_idea) {
        const contentBlock2 = htmlToDraft(_idea);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setIdea(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setIdeaContentState(_contentState);
        } else {
          setIdea(null);
          setIdeaContentState(null);
        }
      }
      let _investment = selectedTask?.investment_description;

      if (_investment) {
        const contentBlock2 = htmlToDraft(_investment);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setInvestments(editorState);

          let _contentState = convertToRaw(editorState.getCurrentContent());
          setInvestmentsContentState(_contentState);
        } else {
          setInvestments(null);
          setInvestmentsContentState(null);
        }
      }
      let _result = selectedTask?.result_description;

      if (_result) {
        const contentBlock2 = htmlToDraft(_result);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setEffects(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setEffectsContentState(_contentState);
        } else {
          setEffects(null);
          setEffectsContentState(null);
        }
      }
    }
  }, [selectedTask, show]);
  const handleChange = (value, field) => {
    if (!showUpdateBtn) {
      setShowUpdateBtn(true);
    }
    if (!showSaveBtn) {
      setShowSaveBtn(true);
    }
    if (setShowCloseConfirmation) {
      setShowCloseConfirmation(true);
    }
    if (field === "title") {
      setTitle({ value: value, error: false });
    } else if (field === "factors") {
      setFactors(value);
    } else if (field === "investments") {
      setInvestments(value);
    } else if (field === "idea") {
      setIdea(value);
    } else if (field === "effects") {
      setEffects(value);
    }
  };

  const handleSubmit = async (action, archive) => {
    if (!title?.value) {
      setTitle({ ...title, error: true });
      return;
    }

    try {
      setLoading(true);

      let tasklist_id = droppableColumn
        ? droppableColumn
        : selectedColumn
        ? selectedColumn
        : columnId
        ? columnId
        : null;

      let taskObject = {
        board_id: parseInt(params?.board_id),
        title: title?.value,
        tasklist_id: tasklist_id ? parseInt(tasklist_id) : null,
        idea_bank_factor_description: draftToHtml(factorsContentState),
        idea_for_change_description: draftToHtml(ideaContentState),
        investment_description: draftToHtml(investmentsContentState),
        result_description: draftToHtml(effectsContentState),
        priority: priority,
        post_status: "publish",
      };

      if (action === "create") {
        taskObject["parent_task_id"] = selectedTask?.id
          ? selectedTask?.id
          : null;
        await dispatch(
          addTask({
            data: taskObject,
            columnId: droppableColumn ? droppableColumn : columnId,
          })
        );
        if (archive) {
          let archiveTaskObject = {
            id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
            post_status: "archive",
          };

          await dispatch(
            archiveTask({
              data: archiveTaskObject,
              columnId: draggableColumn,
              task: selectedTask,
            })
          );
        }
      } else {
        if (selectedColumn) {
          if (!taskObject.idea_bank_factor_description) {
            delete taskObject["idea_bank_factor_description"];
          }
          if (!taskObject.idea_for_change_description) {
            delete taskObject["idea_for_change_description"];
          }
          if (!taskObject.investment_description) {
            delete taskObject["investment_description"];
          }
          if (!taskObject.result_description) {
            delete taskObject["result_description"];
          }

          taskObject["id"] = selectedTask?.id;

          await dispatch(
            updateTask({ data: taskObject, columnId: selectedColumn })
          );
        }
      }

      resetState();
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
        setShowUpdateBtn(false);
        setShowSaveBtn(false);
      }

      setLoading(false);
      setDisplayPrompt(false);
      handleClose(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const handlePriority = (value) => {
    if (!showUpdateBtn) {
      setShowUpdateBtn(true);
    }
    if (!showSaveBtn) {
      setShowSaveBtn(true);
    }
    setPriority(value);
  };
  const handleArchiveCard = async () => {
    try {
      setLoading(true);

      let archiveTaskObject = {
        id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
        post_status: "archive",
      };
      await dispatch(
        archiveTask({
          data: archiveTaskObject,
          columnId: selectedColumn,
          task: selectedTask,
        })
      );
      resetState();
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setLoading(false);
      setDisplayPrompt(false);
      handleClose();
    } catch (error) {
      setLoading(false);
    }
  };
  const handleUnarchiveCard = async () => {
    try {
      setLoading(true);
      let archiveTaskObject = {
        id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
        post_status: "publish",
      };
      await dispatch(
        unArchiveTask({
          data: archiveTaskObject,
          columnId: selectedColumn,
          task: selectedTask,
        })
      );
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      resetState();
      setLoading(false);

      setDisplayPrompt(false);
      handleClose();
    } catch (error) {
      setLoading(false);
    }
  };
  const _handleCloseLocal = () => {
    if (showUpdateBtn || showSaveBtn) {
      setDisplayPrompt(true);
    } else {
      setDisplayPrompt(false);
      handleClose();
    }
  };
  useEffect(() => {
    setDisplayPrompt(false);
  }, []);
  return (
    <Offcanvas
      show={show}
      onHide={() => {
        _handleCloseLocal();
      }}
      size="lg"
      placement="end"
      aria-labelledby="contained-modal-title-vcenter"
      fullscreen={"sm-down"}
      backdrop
      style={{ margin: "0rem", width: "70%" }}
    >
      <Offcanvas.Header closeButton className="p-1">
        <Offcanvas.Title
          className="  font-weight-bold"
          style={{ width: "100%" }}
        >
          <Col
            lg="6"
            className="d-flex justify-content-between align-item-center m-2"
          >
            <h3 className="d-flex mb-0 align-items-center">
              <span className="d-flex align-items-center mx-2  justify-content-center bg-light-red text-white title-number-background">
                2
              </span>
              {columnTitle}
            </h3>
            {showSaveBtn && !selectedTask ? (
              <Button
                style={{
                  height: "43px",
                  fontSize: "13px",
                  borderRadius: "32px",
                }}
                variant="light-red text-white rounded px-3 mx-3"
                onClick={() => handleSubmit("create")}
                disabled={loading}
                className="save-new-card"
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  translation("buttons.save")
                )}
              </Button>
            ) : null}
            {showUpdateBtn && selectedTask && !droppableColumn ? (
              <Button
                style={{
                  height: "32px",
                  padding: "0px 0px",
                  fontSize: "13px",
                }}
                variant="light-red text-white rounded"
                onClick={() => handleSubmit("update")}
                className="mx-3 px-3 pull-right update-selected"
                disabled={loading}
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  translation("buttons.update")
                )}
              </Button>
            ) : null}
          </Col>
          <Col lg="6"></Col>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0 idea-bank">
        {setApiLoading ? (
          <div className="container-fluid px-3">
            <div className="d-flex justify-content-center mt-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </div>
        ) : (
          <Row>
            <Col
              lg="6"
              md="12"
              style={{ overflowY: "scroll", height: "100vh" }}
            >
              <Form>
                <div className="">
                  <div className="d-lg-flex flex-lg-column">
                    <Form.Group className="mb-2 pt-2">
                      <Form.Label>
                        <b className="text-capitalize">
                          {translation("task_forms.idea_bank.field1.label")}
                        </b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={translation(
                          "task_forms.idea_bank.field1.placeholder"
                        )}
                        value={title?.value
                          .substring(0, 45)
                          .replaceAll("&amp;", "&")}
                        onChange={(e) => {
                          handleChange(e.target.value, "title");
                        }}
                        isInvalid={title?.error}
                        style={{
                          fontSize: "14px",
                          padding: "0.5rem 0.5rem",
                          borderRadius: "0px",
                        }}
                      />
                      {title?.error && (
                        <Form.Control.Feedback type="invalid">
                          {translation("task_forms.idea_bank.field1.error")}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </div>

                  <Col>
                    <div className="d-flex justify-content-left mb-4 ">
                      <div style={wrapperStyle}>
                        <p>
                          <b>
                            {translation("task_forms.idea_bank.field2.label")}
                          </b>
                        </p>
                        <div className="p-1">
                          <SliderWT
                            min={0}
                            max={10}
                            defaultValue={priority}
                            value={priority}
                            marks={{
                              0: 0,
                              1: 1,
                              2: 2,
                              3: 3,
                              4: 4,
                              5: 5,
                              6: 6,
                              7: 7,
                              8: 8,
                              9: 9,
                              10: 10,
                            }}
                            step={null}
                            onChange={(val) => {
                              handlePriority(val);
                              setShowCloseConfirmation(false);
                            }}
                            tipFormatter={(value) => {
                              switch (value) {
                                case 0:
                                  return (
                                    <div style={{ width: "70px" }}>
                                      {translation(
                                        "task_forms.idea_bank.field2.0"
                                      )}
                                    </div>
                                  );
                                case 1:
                                case 2:
                                case 3:
                                  return (
                                    <div style={{ width: "70px" }}>
                                      {" "}
                                      {translation(
                                        "task_forms.idea_bank.field2.1"
                                      )}
                                    </div>
                                  );
                                case 4:
                                case 5:
                                case 6:
                                  return (
                                    <div style={{ width: "70px" }}>
                                      {" "}
                                      {translation(
                                        "task_forms.idea_bank.field2.2"
                                      )}
                                    </div>
                                  );

                                case 7:
                                case 8:
                                case 9:
                                  return (
                                    <div style={{ width: "70px" }}>
                                      {" "}
                                      {translation(
                                        "task_forms.idea_bank.field2.3"
                                      )}
                                    </div>
                                  );
                                case 10:
                                  return (
                                    <div style={{ width: "70px" }}>
                                      {" "}
                                      {translation(
                                        "task_forms.idea_bank.field2.4"
                                      )}
                                    </div>
                                  );
                                default:
                                  return "";
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>

                <Form.Group>
                  <Form.Label>
                    <b> {translation("task_forms.idea_bank.field3.label")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={factors}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "factors")}
                    onChange={(e) => {
                      setFactorsContentState(e);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    <b>{translation("task_forms.idea_bank.field4.label")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={idea}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "idea")}
                    onChange={(e) => {
                      setIdeaContentState(e);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    <b>{translation("task_forms.idea_bank.field5.label")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={investments}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "investments")}
                    onChange={(e) => {
                      setInvestmentsContentState(e);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    <b>{translation("task_forms.idea_bank.field6.label")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={effects}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "effects")}
                    onChange={(e) => {
                      setEffectsContentState(e);
                    }}
                  />
                </Form.Group>
              </Form>
              <div>
                {/* div as footer  */}
                {selectedTask && droppableColumn ? (
                  <Row>
                    <div className="me-5 task-moved">
                      <Button
                        variant="light-red text-white rounded"
                        onClick={() => handleSubmit("create", false)}
                        className="mb-2"
                        disabled={loading}
                        style={{ height: "43px" }}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <>
                            {translation("buttons.save_and_archive.text1")}
                            <b>
                              {" "}
                              {translation(
                                "buttons.save_and_archive.text3"
                              )}{" "}
                            </b>
                            {translation("buttons.save_and_archive.text2")}
                          </>
                        )}
                      </Button>
                      <Button
                        variant="light-red text-white rounded"
                        onClick={() => handleSubmit("create", true)}
                        disabled={loading}
                        style={{ height: "43px" }}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <>
                            {translation("buttons.save_and_archive.text1")}
                            <b>
                              {" "}
                              {translation(
                                "buttons.save_and_archive.text4"
                              )}{" "}
                            </b>
                            {translation("buttons.save_and_archive.text2")}
                          </>
                        )}
                      </Button>
                    </div>
                  </Row>
                ) : selectedTask && selectedColumn ? (
                  <div
                    className="d-flex justify-content-left task-btns"
                    style={{ width: "100%" }}
                  >
                    <div className="update-exist">
                      <Button
                        // update button
                        style={{
                          height: "32px",
                          padding: "0px 0px",
                          fontSize: "13px",
                          marginRight: "10px",
                        }}
                        variant="light-red text-white rounded px-3"
                        onClick={() => handleSubmit("update")}
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          translation("buttons.update")
                        )}
                      </Button>
                    </div>
                    <div className="archive-delete">
                      {selectedTask?.post_status === "publish" ? (
                        <Button
                          style={{
                            height: "32px",
                            padding: "0px 0px",
                            fontSize: "13px",
                            marginRight: "10px",
                          }}
                          variant="light-red text-white rounded px-3"
                          onClick={() => {
                            handleArchiveCard();
                          }}
                          className="archive-card"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            translation("buttons.archive_card")
                          )}
                        </Button>
                      ) : (
                        <Button
                          style={{
                            height: "32px",
                            padding: "0px 0px",
                            fontSize: "13px",
                            marginRight: "10px",
                          }}
                          variant="light-red text-white rounded px-3"
                          onClick={() => {
                            handleUnarchiveCard();
                          }}
                          className="unarchive-card"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            translation("buttons.unarchive_card")
                          )}
                        </Button>
                      )}
                      <Button
                        style={{
                          height: "32px",
                          padding: "0px 0px",
                          fontSize: "13px",
                          marginRight: "10px",
                        }}
                        variant="light-red text-white rounded px-3"
                        onClick={() => handleDelete()}
                        className="delete-card"
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          translation("buttons.delete_card")
                        )}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <Button
                    style={{
                      height: "43px",
                      fontSize: "13px",
                      borderRadius: "32px",
                      marginRight: "10px",
                    }}
                    variant="light-red text-white rounded px-3"
                    onClick={() => handleSubmit("create")}
                    disabled={loading}
                    className="save-card"
                  >
                    {loading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      translation("buttons.save")
                    )}
                  </Button>
                )}
              </div>
            </Col>
            <Col className="p-0 " lg="6" md="12">
              {!selectedTask ? (
                <div className="d-flex justify-content-center align-items-center h-100 new-card-comment">
                  <img
                    src={noCommentImg}
                    alt="No-Comments"
                    style={{ width: "200px" }}
                  />
                </div>
              ) : (
                <>
                  <Tabs
                    defaultActiveKey="commentsKey"
                    id="uncontrolled-tab-example"
                    className="mb-3 sustain-tabs bg-white"
                    fill
                  >
                    <Tab
                      eventKey="commentsKey"
                      title={translation("task_forms.comments.commentsHeading")}
                    >
                      {selectedTask && droppableColumn ? (
                        <div className="d-flex justify-content-center align-items-center no-comments-container">
                          <img
                            src={noCommentImg}
                            alt="No-Comments"
                            style={{ width: "200px" }}
                          />
                        </div>
                      ) : (
                        <AllComments
                          task_id={selectedTask?.id}
                          color="light-red"
                          taskComments={allComments}
                          tasklist_id={
                            columnId
                              ? columnId
                              : droppableColumn
                              ? droppableColumn
                              : selectedColumn
                              ? selectedColumn
                              : null
                          }
                        />
                      )}
                      {/* </div> */}
                    </Tab>
                    <Tab eventKey="history" title={translation("history")}>
                      <div className="col-12 px-2">
                        <History
                          taskDate={selectedTask.task_date}
                          history={selectedTask?.history}
                          getColumnNo={getColumnNo}
                          config={config}
                          board={board}
                        />
                      </div>
                    </Tab>
                  </Tabs>
                </>
              )}
            </Col>
            <PromptBox
              show={displayPrompt}
              handleClosePrompt={() => {
                setShowCloseConfirmation(false);
                setShowUpdateBtn(false);
                setShowSaveBtn(false);
                setTimeout(() => {
                  setDisplayPrompt(false);
                  handleClose();
                }, 100);
              }}
              title={translation("changes_not_saved")}
              message={translation("select_changes")}
              handleClose={() => {
                setDisplayPrompt(false);
              }}
              handleSave={() => {
                if (selectedTask) {
                  handleSubmit("update");
                } else {
                  handleSubmit("create");
                }
              }}
              isLoading={loading}
            />
          </Row>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};
export default withCookies(IdeaBank);
